import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ColDef } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { ConfirmApprovalModalComponent } from '../../Modalla-Popup/confirm-approval-modal/confirm-approval-modal.component';
import { ConfirmRejectionModalComponent } from '../../Modalla-Popup/confirm-rejection-modal/confirm-rejection-modal.component';
import { ConfirmSendToFirstAidModalComponent } from '../../Modalla-Popup/confirm-send-to-first-aid-modal/confirm-send-to-first-aid-modal.component';
import { FormApprovalSuccessModalComponent } from '../../Modalla-Popup/form-approval-success-modal/form-approval-success-modal.component';
import { FormRejectionSuccessModalComponent } from '../../Modalla-Popup/form-rejection-success-modal/form-rejection-success-modal.component';

@Component({
  selector: 'app-all-notes-list',
  templateUrl: './all-notes-list.component.html',
  styleUrls: ['./all-notes-list.component.scss']
})
export class AllNotesListComponent {

  themeClass = 'ag-theme-quartz';
  // dialogRef!: NbDialogRef<any>;
  paginationPageSize = 10;
  paginationPageSizeSelector = [10, 25, 50, 100];
  gridOptions = { pagination: true, paginationPageSize: this.paginationPageSize };
  public defaultColDef: ColDef = { filter: "agTextColumnFilter", floatingFilter: true, sortable: true };
  currentPage = 1; // Current page
  gridData: any[] = []; // Replace with your actual data source





  constructor(
    private api: SevaProfileService,
    private dialogService: NbDialogService,
    private toastr: ToastrService,
    private router: Router
  ) { }
  ApplicationGuid:any
  ngOnInit() {
    this.ApplicationGuid = history?.state?.rowData?.ApplicationGuid;
    this.getApplicantData(this.currentPage);
  }

  getApplicantData(page: number) {
    const size = this.paginationPageSize; // You can update this as needed
    const start = (page - 1) * size; // Calculate the starting index for pagination
   this.api.getById('Applicant/applications/GetNotes', { ApplicationGuid: this.ApplicationGuid }).subscribe((response: any) => {
        if (response.Data ) {
          this.gridData = response.Data;
        }
      });
  }

  columnDefs: ColDef[] = [
    { headerName: 'Notes', field: 'Notes', sortable: true, filter: true },
    { headerName: 'SubmittedBy', field: 'SubmittedBy', sortable: true, filter: true },
   
   



    { 
      headerName: 'SubmittedOn', 
      field: 'SubmittedOn', 
      sortable: true, 
      filter: true, 
      valueFormatter: (params: any) => {
        const value = params.value;
        if (!value) return '';
    
        const date = new Date(value);
        if (isNaN(date.getTime())) return String(value);
    
        // Format: dd-MMM-yyyy hh:mm:ss a
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' }); // Sep
        const year = date.getFullYear();
    
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
    
        hours = hours % 12;
        hours = hours ? hours : 12; // 0 → 12
        const formattedTime = `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    
        return `${day}-${month}-${year} ${formattedTime}`;
      } 
    }
,


    { headerName: 'NotesCreator', field: 'NotesCreator', sortable: true, filter: true },
  ];









  exportToCSV(): void {
    // Prepare the headers
    const headers = this.columnDefs.map((col) => col.headerName);

    // Map grid data to CSV format
    const rows = this.gridData.map((row) =>
      this.columnDefs.map((col) => row[col.field || ''])
    );

    // Create CSV content
    const csvContent = [headers, ...rows]
      .map((row) => row.join(','))
      .join('\n');

    // Create a Blob and download it
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'InProcessApplicants.csv';
    link.click();
  }


  navigateToPreview(params: any) {
    const link = document.createElement('a');
    link.href = 'javascript:void(0)';
    link.innerText = params.data.Name;
    link.addEventListener('click', () => {
      this.router.navigate(['/gao/preview'], { state: { rowData: params.node.data } });
    });
    return link;
  }


  profilePicCellRenderer(params: any): string {
    if (params.value) {
      return `<img src="${params.value}" alt="Profile Pic" style="width: 40px; height: 40px; border-radius: 50%;" />`;
    }
    return '<span>No Image</span>';
  }

  isApproveModalaOpen(params: any) {
      if(params.data.ApplicationState == "Incomplete"){
        return `<div class="custom-status blocked">${params.data.ApplicationState}</div>`;
      }else{
        return `<div class="custom-status onboarded">${params.data.ApplicationState}</div>`;
      }

  }



  customActionCellRenderer(params: any) {
    const cellElement = document.createElement('div');
    cellElement.classList.add('center-column');
    const button = document.createElement('a');
    button.innerHTML = '🗑️';
    button.classList.add('action-icon', 'custom-icon-btn');
    button.title = 'Delete';
    button.addEventListener('click', () => {
      // Perform your action
      this.showFun(params);
    });
    cellElement.appendChild(button);
    return cellElement;
  }

  showFun(arg: any) {
    console.log("-------------", arg.data);
  }

  // Pagination methods
  goToFirstPage(): void {
    this.currentPage = 1;
    this.getApplicantData(this.currentPage);
  }

  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getApplicantData(this.currentPage);
    }
  }



  onGridReady(params: any): void {
    params.api.sizeColumnsToFit();
  }



  onPageSizeChange(): void {
    // Reset to the first page whenever the page size changes
    this.currentPage = 1;
    this.gridOptions.paginationPageSize = this.paginationPageSize;
    this.getApplicantData(this.currentPage);
  }































}

